export const StepIndicator = ({ steps, currentStep }) => {
  if (steps.length <= 1) return null;
  
  return (
    <div className="mb-6">
      <div className="flex justify-between">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`flex-1 text-center py-2 ${
              index === currentStep
                ? 'border-b-2 border-blue-600 text-blue-600'
                : index < currentStep
                ? 'border-b-2 border-green-500 text-green-500'
                : 'border-b-2 border-gray-300 text-gray-400'
            }`}
          >
            {step.title || `Step ${index + 1}`}
          </div>
        ))}
      </div>
    </div>
  );
};